import { render, staticRenderFns } from "./cModalDescriptionAnterior.vue?vue&type=template&id=b99a16e4"
import script from "./cModalDescriptionAnterior.vue?vue&type=script&lang=js"
export * from "./cModalDescriptionAnterior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports